import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "../utils/constants";

const LearnersReportSlice = createSlice({
  name: "LearnersReport",
  initialState: {
    loader: false,
    error: null,
    success: null,
    categoryPoints: { totalPoints: 0, completedCourses: 0 },
    foundationStatus: {
      isFoundationCompleted: false,
      totalMandatory: 0,
      completedMandatory: 0,
    },
    topLearners: [],
    topLearnersLoaded: false,
    foundationReport: null,
    learnersDetails: [],
  },
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    resetStatus: (state) => {
      state.error = null;
      state.success = null;
    },
    setCategoryPoints: (state, action) => {
      state.categoryPoints = action.payload;
    },
    setFoundationStatus: (state, action) => {
      state.foundationStatus = action.payload;
    },
    setTopLearners: (state, action) => {
      state.topLearners = action.payload;
      state.topLearnersLoaded = true;
    },
    setFoundationReport: (state, action) => {
      state.foundationReport = action.payload;
    },
    setLearnersDetails: (state, action) => {
      state.learnersDetails = action.payload || [];
    },
  },
});

export const {
  setLoader,
  setError,
  setSuccess,
  resetStatus,
  setCategoryPoints,
  setFoundationStatus,
  setTopLearners,
  setFoundationReport,
  setLearnersDetails,
} = LearnersReportSlice.actions;

export default LearnersReportSlice.reducer;

export function uploadLearnersReport(businessUnit, file) {
  return (dispatch) => {
    dispatch(setLoader(true));
    dispatch(resetStatus());
    const formData = new FormData();
    formData.append("file", file);
    formData.append("businessUnit", businessUnit);

    axios
      .post(`${BASE_API_URL}/upload-learners-report`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(
          setSuccess(
            res.data.message || "Learners Report uploaded successfully",
          ),
        );
      })
      .catch((err) => {
        dispatch(setLoader(false));
        dispatch(setError(err.response?.data?.message || "Upload failed"));
      });
  };
}

export function getCategoryPoints(enterpriseId, category) {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .post(
        `${BASE_API_URL}/getCategoryPoints`,
        { enterpriseId, category },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        dispatch(setCategoryPoints(res.data));
        dispatch(setLoader(false));
      })
      .catch(() => {
        dispatch(setError("Failed to load category points"));
        dispatch(setLoader(false));
      });
  };
}

export function fetchFoundationStatus(enterpriseId) {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .post(
        `${BASE_API_URL}/getFoundationStatus`,
        { enterpriseId },
        {
          headers: { Authorization: localStorage.getItem("token") },
        },
      )
      .then((res) => {
        dispatch(setFoundationStatus(res.data));
        dispatch(setLoader(false));
      })
      .catch(() => {
        dispatch(setError("Failed to fetch Foundation status"));
        dispatch(setLoader(false));
      });
  };
}

export function fetchTopLearners(businessUnit) {
  return (dispatch) => {
    dispatch(setLoader(true));
    dispatch(setError(null));

    axios
      .get(`${BASE_API_URL}/getTopLearners`, {
        params: { businessUnit },
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((res) => {
        dispatch(setTopLearners(res.data));
        dispatch(setLoader(false));
      })
      .catch(() => {
        dispatch(setError("Failed to fetch top learners"));
        dispatch(setLoader(false));
      });
  };
}

export function getFoundationReport(hub = "Core Hub") {
  return (dispatch) => {
    dispatch(setLoader(true));
    dispatch(setError(null));

    axios
      .get(`${BASE_API_URL}/powerBI/foundation-report`, {
        params: { hub },
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((res) => {
        dispatch(setFoundationReport(res.data?.[0] || null));
        dispatch(setLoader(false));
      })
      .catch(() => {
        dispatch(setError("Failed to load report"));
        dispatch(setLoader(false));
      });
  };
}

export function getLearnersDetails() {
  return (dispatch) => {
    dispatch(setLoader(true));
    dispatch(setError(null));

    axios
      .get(`${BASE_API_URL}/learnersDetails`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setLearnersDetails(res.data || []));
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.error("Error fetching learners report:", error);
        dispatch(setError("Failed to fetch learners details"));
        dispatch(setLoader(false));
      });
  };
}
